import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#1f337d',
    secondary: '#F4F4F5',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

var headerTextDark = true

switch (window.env.VUE_APP_AMBIENTE) {
  case 'master3ep':
    themes = {
      light: {
        primary: '#176f31',
        secondary: '#176f31',
        accent: '#94ff29',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    break
  case 'nellpay':
    themes = {
      light: {
        primary: '#1f337d',
        secondary: '#1f337d',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
  case 'brsurgery':
    themes = {
      light: {
        primary: '#1f337d',
        secondary: '#1f337d',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
  case 'tradicash':
    themes = {
      light: {
        primary: '#005836',
        secondary: '#005836',
        accent: '#90EE90',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
  case 'creditosimples':
    themes = {
      light: {
        primary: '#1f337d',
        secondary: '#1f337d',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
  case 'mrm':
    themes = {
      light: {
        primary: '#8a62ff',
        secondary: '#8B62FF',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
  case 'iriom':
    themes = {
      light: {
        primary: '#E7AF14',
        secondary: '#000000',
        accent: '#90EE90',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    headerTextDark = false
    break
  case 'work8':
    themes = {
      light: {
        primary: '#28A8E0',
        secondary: '#28A8E0',
        accent: '#595A5C',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    headerTextDark = false
    break
  case 'precatorios':
    themes = {
      light: {
        primary: '#304755',
        secondary: '#45E200',
        accent: '#595A5C',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
  case 'antecsalarial':
    themes = {
      light: {
        primary: '#304755',
        secondary: '#45E200',
        accent: '#595A5C',
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
  case 'finanfastreneg':
    themes = {
      light: {
        primary: '#0066CC',
        secondary: '#F4F4F5',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    headerTextDark = false
    break
  case 'featbankltda':
    themes = {
      light: {
        primary: '#217571',
        secondary: '#00E96A',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    headerTextDark = false
    break
  case 'ideal_creditosimples':
    themes = {
      light: {
        primary: '#28285a',
        secondary: '#d71e1e',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    headerTextDark = true
    break
  case 'diserv_ep':
    themes = {
      light: {
        primary: '#F55A00',
        secondary: '#FAFAFA',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    headerTextDark = false
    break
}

var headerColor = themes.light.primary
let background = '/assets/imgs/background.svg'
let logo = '/assets/imgs/logo.svg'
let logoLogin = '/assets/imgs/logo.svg'

try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/logo-inverted.svg')
    logoLogin = '/assets/imgs/' + localStorage.ambiente + '/logo-inverted.svg'
  }
} catch {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/logo.svg')
    logoLogin = '/assets/imgs/' + localStorage.ambiente + '/logo.svg'
  }
}

try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/background.svg')
    background = '/assets/imgs/' + localStorage.ambiente + '/background.svg'
    require('@/assets/imgs/' + localStorage.ambiente + '/logo.svg')
    logo = '/assets/imgs/' + localStorage.ambiente + '/logo.svg'

    var favicon = document.getElementById('custom-favicon')
    favicon.setAttribute('href', '/assets/imgs/' + localStorage.ambiente + '/favicon.svg')
  }
} catch { }

switch (window.env.VUE_APP_AMBIENTE) {
  case 'finanfastreneg':
    headerColor = themes.light.secondary
    break
  case 'featbankltda':
    headerColor = '#FFFFFF'
    break
  case 'diserv_ep':
    headerColor = '#FAFAFA'
    break
}

export default {
  dark: false,
  options: {
    customProperties: true,
    dense: false,
    toolbar: { color: headerColor, dark: headerTextDark },
    sliderIcon: {
      color: '#F4F4F5'
    }
  },
  background,
  logo,
  logoLogin,
  themes: themes
}
